/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class InquiryTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inquiryType: this.props.inquiryType,
      style: null,
      inquiryTypeList: [
        {type: '회원정보', text: '회원정보'},
        {type: '예약관련', text: '예약관련'},
        {type: '서비스 이용', text: '서비스 이용'},
        {type: '이벤트', text: '이벤트'},
        {type: '기타', text: '기타'}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeInquiryTypeEvent = (e) => {
    this.setState({ inquiryType: e.target.dataset.inquirytype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="inquiry-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-inquirytype={this.state.inquiryType} data-type="inquiryType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.inquiryTypeList.map((entity, index) => <li key={index} className={this.state.inquiryType === entity.type ? 'active' : ''}><a href={null} data-inquirytype={entity.type} onClick={this._doChangeInquiryTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default InquiryTypePop;